module.exports = __webpack_public_path__ + "static/img/exam_2.c28ce80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/webSite/exam_2.png
// module id = u6Ig
// module chunks = 1